import React from "react";
import axios from "axios";
import { Box, Typography, Button } from "@mui/material";

import { Language } from "../../models/LanguageModel";

import withStyles from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { theme } from '../../utils/theme';
import { translate } from "i18n";
//import FlagIcon from "../../components/FlagIconFactory";
import ReactCountryFlag from "react-country-flag"
import { styled } from '@mui/system';
import ToggleButton from '@mui/material/ToggleButton';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({}) => ({
  grouped: {
    "height": "8em",
    "border": "none",
    "padding": theme.spacing(0, 1),
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

export class LanguageSwitcher extends React.Component {
  public state = { language: localStorage.getItem("language") };
  private languages = [
    {
      name: "English",
      icon_id: "gb",
      lang_id: "en",
    },
    {
      name: "Français",
      icon_id: "fr",
      lang_id: "fr",
    } /*,
        {
          name: 'Swedish',
          icon_id: 'se',
          lang_id: 'se'
        }*/,
  ];
  private handleLanguage = (event: React.MouseEvent<HTMLElement>, newLanguage: string) => {
    this.setState({ language: newLanguage });
  };
  private async handleLanguageSave(): Promise<void> {
    const data = {
      login: localStorage.getItem("login"),
      language: this.state.language,
    };

    if (data.language) {
      localStorage.setItem("language", data.language);
    }
    await axios.patch(`/user/language`, data).catch((e) => {
      console.log("Failed to update password: ", e);
    });
  }

  private browserUseSvgIcons(): boolean | undefined {
    const browser = navigator.userAgent

    if ((browser.indexOf("Opera") != -1 || browser.indexOf('OPR')) != -1) return undefined
    else if (browser.indexOf("Edg") != -1) return true;
    else if (browser.indexOf("Chrome") != -1) return true;
    else if (browser.indexOf("Safari") != -1) return undefined;
    else if (browser.indexOf("Firefox") != -1) return undefined
    else if (browser.indexOf("MSIE") != -1) return true; // if IE > 10

    return undefined
  }

  // TODO manage ReactCountryFlag with language configuration:  <FlagIcon code={language.icon_id} size="3x" />
  public render(): JSX.Element {
    return (
      <Box marginLeft={2} p={2} style={{ width: "50em" }}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <StyledToggleButtonGroup
            size="small"
            value={this.state.language}
            exclusive
            onChange={this.handleLanguage}
            aria-label="text alignment">
            {this.languages.map((language: Language) => (
              <ToggleButton
                value={language.lang_id}
                aria-label={language.name}
                key={language.name}
                data-cy={`settings-flag-${language.lang_id}-button`}>
                <Box component="div" p="1rem">
                  <ReactCountryFlag
                    countryCode={language.icon_id} 
                    style={{fontSize:'5em'}}
                    title={language.name}
                    svg={this.browserUseSvgIcons()}
                  />
                </Box>
              </ToggleButton>
            ))}
          </StyledToggleButtonGroup>
        </Box>
        <Button
          onClick={() => this.handleLanguageSave()}
          variant="contained"
          color="primary"
          id="saveLanguage"
          disabled={this.state.language === localStorage.getItem("language") || this.state.language === null}
          data-cy="settings-save-language-button"
          style={{ marginTop: "1em", width: "16em" }}>
          {translate("save")}
        </Button>
      </Box>
    );
  }
}
